import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import { useDispatch, useSelector } from "react-redux";
import { getFunctions } from "actions/workflows";
import NiceModal from "@ebay/nice-modal-react";

const Functions = ({ navigation }) => {
  const location = useLocation();
  const functions = useSelector((state) => state.workflows.functions);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const [retrievedFunctions, setRetrievedFunctions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (functions.length === 0 && !retrievedFunctions) {
      setRetrievedFunctions(true);
      dispatch(getFunctions());
    } else {
      const keys = ["id", "public_id", "name", "description", "actions"];
      setHead(keys);
      setBody(
        functions.map((funct) => {
          const values = [
            funct.id,
            funct.public_id,
            funct.name,
            funct.description ?? "",
            <></>,
          ];
          return values;
        })
      );
    }
  }, [functions, retrievedFunctions, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editFunction = (row) => {
    const funct = {};
    head.forEach((key, index) => {
      funct[key] = row[index];
    });
    //NiceModal.show('add-function', {function: function});
    navigate(`/admin/function/${funct.public_id}`);
  };

  return (
    <div>
      <CardFullTable
        title="Functions"
        titlebutton={
          <i
            onClick={() => NiceModal.show("add-function")}
            className="fa fa-plus text-sm cursor-pointer"
          />
        }
        head={head}
        body={body}
        color="white"
        onRowClick={(row) => editFunction(row)}
      />
    </div>
  );
};

export default Functions;
